import {lazy} from 'react';

const EventsList = lazy(() => import('./event/EventsList'));

const TestRequest = lazy(() => import('./TestRequest'));

const PatientEvolution = lazy(() => import('./PatientEvolution'));

const PatientPathologyTaskList = lazy(() =>
  import('./PatientPathologyTask/PatientPathologyTaskList')
);

const UserHome = lazy(() => import('./user/UserHome'));

const ProductRecommendationRoutine = lazy(() => import('./ProductRecommendationRoutine'));

const TipLibrary = lazy(() => import('./TipLibrary'));

export default {
  EventsList,
  PatientEvolution,
  PatientPathologyTaskList,
  TestRequest,
  UserHome,
  ProductRecommendationRoutine,
  TipLibrary
};
